import React from 'react';
import {Box} from '@mui/material';


// Create a new context
const QueryContext = React.createContext(
        "Default Value Here"
);

// Create a new hook to use the context
const useQuery = () => {
    const [query, setQuery] =  React.useContext(QueryContext);

    const handleQuery = (value) => {
        setQuery(value);
    }

    return { value: query, onChange: handleQuery }
};

// Create a Context Provider
const QueryContextProvider = ( { children }) => {
  const [query, setQuery] = React.useState("");
  const [msgEnabled, setMsgEnabled] = React.useState(false);

  return (
    <QueryContext.Provider value={[ query, setQuery]}>
      <Box sx={{ display: 'flex' }}>
      {React.Children.map(children, (child) =>
        React.cloneElement(child, { msgEnabled : msgEnabled, setMsgEnabled : setMsgEnabled })
      )}
      </Box>
    </QueryContext.Provider>
  );
};

export { useQuery, QueryContextProvider };